import {
  USERS_ADDED,
  USERS_DELETED,
  USERS_EDITED,
  USER_CONNECTED_TO_SURFER,
  USER_SET_INFORMATIONS,
  USER_SET_LIST_INFORMATION,
  USER_SET_TOKEN,
  USER_SET_LANGUAGE,
  USER_SET_ROLES,
  USER_ADD_EVENT,
} from 'src/app/redux/redux-types';
import { reduxUserTypes } from 'src/types';
import { UserRoleType } from 'src/types/redux/user.redux.types';

export const userDefaultState: reduxUserTypes.StateType = {
  id: undefined,
  userName: '',
  name: undefined,
  surname: undefined,
  email: undefined,
  telephone: undefined,
  password: undefined,
  organization: undefined,
  userRoles: [],
  events: [],
  token: undefined,
  tokenc: undefined,
  isLocalUser: false,

  // tokeng: undefined,
  authenticated: false,
  isConnectedToSurfer: false,
  isRegistered: undefined,
  sessionTime: undefined,
  preferredLanguage: 'en',
};

export const userListDefaultState: reduxUserTypes.ListStateType = {
  usersList: [],
};

export const userReducer = (state = userDefaultState, action: reduxUserTypes.ActionType): reduxUserTypes.StateType => {
  switch (action.type) {
    case USER_SET_INFORMATIONS:
      return {
        ...state,
        id: action.payload.id,
        userName: action.payload.userName,
        // userRoles: action.payload.userRoles,
        email: action.payload.email,
        events: action.payload.events,
        isRegistered: action.payload.isRegistered,
        sessionTime: action.payload.sessionTime,
        isLocalUser: action.payload.isLocalUser,
        name: action.payload.name,
        surname: action.payload.surname,
        preferredLanguage: action.payload.preferredLanguage,
      };

    case USER_SET_TOKEN:
      return {
        ...state,
        token: action.payload.token,
        tokenc: action.payload.tokenc,
        // tokeng: action.payload.tokeng,
        authenticated: !!action.payload.token,
      };
    case USER_CONNECTED_TO_SURFER:
      return {
        ...state,
        isConnectedToSurfer: action.payload,
      };

    case USER_SET_ROLES:
      return {
        ...state,
        userRoles: action.payload,
      };
    case USER_ADD_EVENT:
      if (state.events.includes(action.payload)) {
        return state;
      }
      return {
        ...state,
        events: [...state.events, action.payload],
      };

    case USER_SET_LANGUAGE:
      return {
        ...state,
        preferredLanguage: action.payload,
      };

    default:
      return state;
  }
};

export const userListReducer = (
  state = userListDefaultState,
  action: reduxUserTypes.ActionType,
): reduxUserTypes.ListStateType => {
  switch (action.type) {
    case USER_SET_LIST_INFORMATION:
      return {
        ...state,
        usersList: action.payload,
      };
    case USERS_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.usersList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        usersList: [action.payload, ...state.usersList],
      };
    case USERS_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.usersList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        usersList: [
          ...state.usersList.slice(0, updateIndex),
          action.payload,
          ...state.usersList.slice(updateIndex + 1),
        ],
      };
    case USERS_DELETED:
      return {
        ...state,
        usersList: state.usersList.filter((o) => o.id !== action.payload),
      };

    default:
      return state;
  }
};
